<template>
    <div>
        <canvas ref="lineChart"></canvas>
    </div>
</template>
  
<script>
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
    props: {
        labels: {
            required: true,
            type: Array
        },
        dataset: {
            required: true,
            type: Object
        },
        legend_position: {
            required: false,
            type: String || null,
            default: null
        },
        height: {
            required: false,
            type: Number,
            default: 380
        },
        background_color: {
            type: Object,
            required: false
        }
    },
    mounted() {
        this.renderChart()
        this.setHeight()
    },
    watch: {
        dataset(newV, oldV) {
            if (newV == oldV) return
            this.updateChart()
        },
        labels(newV, oldV) {
            if (newV == oldV) return
            this.updateChart()
        }
    },
    methods: {
        updateChart() {
            this._lineChart.destroy();
            this.renderChart()
            this.setHeight()
        },
        renderChart() {
            this._lineChart = new Chart(
                this.$refs.lineChart,
                {
                    type: 'line',
                    plugins: [ChartDataLabels],
                    options: {
                        maintainAspectRatio: false,
                        animation: true,
                        responsive: true,
                        plugins: {
                            legend: {
                                display: true,
                                position: this.legend_position,
                                labels: {
                                    usePointStyle: true,
                                    pointStyle: 'rectRounded',
                                    font: {
                                        weight: 'bold',
                                        size: 13,
                                    }
                                }
                            },
                            tooltip: {
                                enabled: true
                            },
                            datalabels: {
                                borderRadius: 4,
                                backgroundColor: function(context) {
                                    return context.dataset.backgroundColor;
                                },
                                color: 'black',
                                display: function (context) {
                                    let val = context.dataset.data[context.dataIndex]                                    
                                    if (val == 0) return false
                                    return true
                                },
                                font: {
                                    size: 13,
                                    weight: 'bold'
                                },
                            }
                        },
                    },
                    data: this.prepareDataset()
                }
            );
        },
        prepareDataset() {
            let result = []
            Object.keys(this.dataset).forEach(key => {
                let temp_payload = {
                    label: key || 'Unknown',
                    data: this.dataset[key],
                    hoverOffset: 4,
                    backgroundColor: this.background_color ? this.background_color[key] : 'rgba(' + this.getRandomValue() + ', ' + this.getRandomValue() + ', ' + this.getRandomValue() + ', 0.8)',
                    borderColor: this.background_color ? this.background_color[key] : 'rgba(' + this.getRandomValue() + ', ' + this.getRandomValue() + ', ' + this.getRandomValue() + ', 0.8)',
                }
                result.push(temp_payload)
            })

            return {
                labels: this.labels,
                datasets: result
            }
        },
        // Function to generate a random color value (0-255)
        getRandomValue() {
            return Math.floor(Math.random() * 256);
        },
        setHeight(){
            const lineChart = this.$refs.lineChart
            const chartHeight = this.height ? this.height : 380;
            lineChart.style.height = `${chartHeight}px`;
        }
    }
}
</script>